import { render, staticRenderFns } from "./UserEmailPopView.vue?vue&type=template&id=85402bf0&"
import script from "./UserEmailPopView.vue?vue&type=script&lang=js&"
export * from "./UserEmailPopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports